import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import { Navigate, useParams } from "react-router-dom";
import Employment from "./pages/Employment";
import { Toaster } from "./components/ui/toaster";

const SlugRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/#${slug}`} replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/employment" element={<Employment />} />
            <Route path="/:slug" element={<SlugRedirect />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
